import axios from 'axios';

export const uploadPlanningFile = file => dispatch =>
  axios.post(`/upload/csv`, file).then(response => response);
